import Icon, { BaseIconProps } from './react-components/Icon'

/**
 * Renders the generated SVG icon ConsolidateCartsIcon as a React component.
 * These icons are rendered with special wrapper helpers via our internal <Icon> component,
 * which is built on top of MUI's <SvgIcon> component.
 * If you're experiencing rendering issues, contact the UIPT team or consult the docs
 * for the underlying components. Do not modify this icon directly. It is a generated file.
 */ const ConsolidateCartsIcon = (props: BaseIconProps) => {
  return (
    <Icon {...props} nativeViewbox="0 0 24 24">
      <path
        d="M9 17C9.55228 17 10 16.5523 10 16C10 15.4477 9.55228 15 9 15C8.44772 15 8 15.4477 8 16C8 16.5523 8.44772 17 9 17Z"
        stroke="#503291"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19 21C19.5523 21 20 20.5523 20 20C20 19.4477 19.5523 19 19 19C18.4477 19 18 19.4477 18 20C18 20.5523 18.4477 21 19 21Z"
        stroke="#503291"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.52778 9H11.0278L12 11.5M12 11.5L13.9129 17.1601C13.9816 17.3632 14.1721 17.5 14.3866 17.5H20.6097C20.8392 17.5 21.0391 17.3439 21.0948 17.1213L22.3448 12.1213C22.4237 11.8057 22.184 11.5 21.8587 11.5C18.1492 11.5 15.8818 11.5 12 11.5Z"
        stroke="#503291"
        strokeLinecap="round"
      />
      <path
        d="M2 4H3.32297C3.73187 4 4.09958 4.24895 4.25144 4.62861L5 6.5M10 13H7.8434C7.63651 13 7.45099 12.8726 7.37673 12.6795L5 6.5M5 6.5H15.3596C15.6849 6.5 15.9236 6.80569 15.8447 7.12127L15.5 8.5"
        stroke="#503291"
        strokeLinecap="round"
      />
    </Icon>
  )
}
export default ConsolidateCartsIcon
